import React from 'react'

export default function SocialMedia() {
  return (
    <div>SocialMedia</div>
  )
}
